<template>
  <div class="module_course page_content entity_detail_instructor" aria-label="Entity Detail Page Content">

    <course-header ref="courseHeader" :course-id="course.uuid" :entityUuid="entityUuid" class="header_entity_learn"></course-header>

    <div class="row page-content">

      <t-o-c-instructor :uuid="course.uuid" :entity-type="entityType" :entity-uuid="entityUuid" :topic-uuid="topicUuid" :sub-topic-uuid="subTopicUuid"></t-o-c-instructor>

      <div class="col-8 course-description ace_sec" aria-label="entity detail section">
        <div class="entity-nav">
          <div class="float-left entity-title-section">
            <span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
            <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
            <span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
            <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
            <span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
            <span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
            <span v-if="entity.fileType === 'externalurl'" class="icon icon-pageURL"></span>
            <span v-if="entity.fileType === 'other'" class="icon icon-pageURL"></span>
            <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
            <span v-if="entity.fileType === 'zip'" class="icon icon-file-zip"></span>
            <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
            <h3 class="entity-title float-left ace_sec_hd">{{entity.title}} </h3>
                <div>
                <b-modal class="full_screen_modal" ref="aiContentModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc>
                  <div slot="modal-header" class="header-section w-100">
                    <div class="popup_head_txt head_txt text-center">
                      <span>{{aiResorce.title}}</span>
                    </div>
                    <div>
                      <button class="btn_close" aria-label="close" @click="closeAiContentModal">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                  </div>
                  <div class="rich-html-container-parent">
                    <div v-html="aiResorce.htmlBody">
                    </div>
                  </div>
                </b-modal>
              </div>
              <div class="loading-spinner">
                <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                  <div class="text-center" style="color: #FFF">
                    <div><i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i></div>
                    <div class="mt-4" v-if="isRecalutingClassAverage">
                      <span>Recalculating Class Average</span>
                    </div>
                  </div>
                </b-modal>
              </div>

          </div>

          <div class="action_menu_container pg_hd_sec_menu" v-if="entity.objectType === 'LearningTopic' || entity.objectType === 'LearningContent' || allowCopyLTILink">
            <div class="action btn_3dot">

              <b-dropdown no-caret class="navigation-menu">
                <template slot="button-content" class="ic_btn">
                  <span class="ic_more"></span>
                </template>

                <div class="links new_menu">

                  <div class="menu_item" v-if="allowCopyLTILink && entity.objectType === 'LearningTopic'">
                    <copy-to-clipboard :text="generateLTIUrlForCMC(course.uuid, entityUuid,nextTOCuuid)">
                      <b-dropdown-item
                        @click="notifyUrlCopiedMessage('LTI')"
                        variant="primary"
                        :aria-label="'Copy lti url for '+entity.title">
                         {{ $t('copyLTIUrl') }}
                      </b-dropdown-item>
                    </copy-to-clipboard>
                  </div>
                  <div class="menu_item" v-if="allowCopyLTILink && entity.objectType === 'LearningContent'">
                    <copy-to-clipboard :text="generateLTIUrl(course.uuid, entity.ancestor,entity.uuid)" v-if="allowCopyLTILink">
                        <b-dropdown-item @click="notifyUrlCopiedMessage('LTI')" variant="primary" :aria-label="'Copy lti url for '+entity.title">
                          {{ $t('copyLTIUrl') }}
                        </b-dropdown-item>
                    </copy-to-clipboard>
                  </div>
                  <div class="menu_item" v-if="entity.fileType === 'assessment'">
                    <copy-to-clipboard :text="entity.rootOriginUuid" >
                        <b-dropdown-item @click="notifyUrlCopiedMessage('Learnosity Reference')" variant="primary" :aria-label="'Copy Learnosity Ref for '+entity.title">
                          {{ $t('copyLearnosityRef') }}
                        </b-dropdown-item>
                    </copy-to-clipboard>
                  </div>
                  <div class="menu_item" v-if="entity.objectType === 'LearningTopic'">
                    <b-dropdown-item @click="openPostMessageEditModal()" variant="primary" :aria-label="'Configure post completion message for '+entity.title">
                      {{ $t('editPostCompletionMsg') }}
                    </b-dropdown-item>
                  </div>
                  <div class="menu_item" v-if="allowEditKC() && entity.fileType === 'assessment'">
                    <b-dropdown-item @click="editKC(entity)" variant="primary" :aria-label="'Edit '+entity.title">
                      {{ $t('edit') }}
                    </b-dropdown-item>
                  </div>

                </div>
              </b-dropdown>

            </div>
          </div>


          <div v-if="entity.objectType === 'LearningTopic'">
            <b-modal ref="postMessageEditModal" class="modal__v22_2" title="Post Completion Message" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>

              <div slot="modal-header" class="w-100">
      					<div class="row">
      						<div class="col-2 hd">
      							<div class="ic_container">

      							</div>
      						</div>
                  <div class="col-8 hd">
      							<div class="hd_txt text-center w-100" style="margin-left: 0px;">
      								<span>Post Completion Message</span>
      							</div>
      						</div>
      						<div class="col-2 btn_container">
      							<button class="btn_close" aria-label="close" title="close the popup" @click="closePostMessageEditModal()">
      								<span class="ic-close"></span>
      							</button>
      						</div>
      					</div>
      				</div>

              <div class="row">
                <div class="col-10 modal_flds_container">

                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <span for="title" id="editCompetencyTitle">Title</span>
                    </div>
                    <div class="col-12 fld_input">
                      <b-form-input class="inputTitle"
                        v-model.trim="messageTitle"
                        type="text"
                        :state="messageTitleState"
                        :aria-label="messageTitle"
                        aria-describedby="editCompetencyTitle">
                      </b-form-input>
                      <b-form-invalid-feedback>
                          Title must not be empty.
                      </b-form-invalid-feedback>
                      </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      <span for="description" id="editMessage">Message</span>
                    </div>
                    <div class="col-12 invalid-feedback" v-if="!messageState">
                      Message must not be empty.
                    </div>
                    <div class="col-12 fld_input">
                      <textarea rows="6" cols="75"
                          v-model="message"
                          :state=messageState
                          aria-labelledby="editMessage">
                      </textarea>
                    </div>
                  </div>

                </div>

              </div>

              <div slot="modal-footer" class="w-100">
                  <b-button @click="saveAndCloseCompetencyLogicMessage()" class="btn button-primary float-right mr-2"> save </b-button>
                  <b-button @click="deleteAndCloseCompetencyLogicMessage()" class="btn button-primary float-right mr-2" v-if="postMessageId"> delete </b-button>
                  <b-button @click="closePostMessageEditModal()" class="btn button-primary float-right mr-2"> cancel </b-button>
              </div>
          </b-modal>

          </div>

          <div class="float-right float-right pt-3 pr-2" v-if="entity.objectType === 'LearningContent'">
            <b-button v-if="prevTOCuuid" :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: prevTOCuuid } }" class="btn button-primary next" aria-label="previous"><span class="float-left"> < </span><span class="btn_txt" v-on:click="scrollUpToC">prev</span></b-button>
            <b-button v-else class="btn button-primary next" disabled><span class="float-left"> < </span><span class="btn_txt" v-on:click="scrollUpToC">prev</span></b-button>
            <b-button v-if="nextTOCuuid" :to="{ name: 'entityDetailInstructor', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: nextTOCuuid } }" class="btn button-primary next mr-0" aria-label="next"><span class="btn_txt" v-on:click="scrollToC">next</span><span> > </span></b-button>
            <b-button v-else class="btn button-primary next mr-0" disabled><span class="btn_txt" v-on:click="scrollToC">next</span><span> > </span></b-button>
          </div>
        </div>
        <div class="entity-content-section col-sm-12">
          <div v-if="entity.type !== 'ASSESSMENT'">
            <template v-if="entity.fileType === 'zip'">
              <p class="ace_sec_txt" style="line-height: 20pt;">
                The {{entity.title}} consist of a single .ZIP file. You will need to download the <b>{{entity.fileName}}</b> file to your PC or Mac (the file is not compatible with a mobile device) and unzip the file. Once unzipped, all of the files will reside in one folder.
              </p>
            </template>
            <template v-else>
              <span class="desc-heading ace_sec_hd" v-if="entity.description">Asset Description</span>
              <span class="asset-description ace_sec_txt" v-html="entity.description"></span>
            </template>
          </div>
          <div v-if="entity.objectType === 'LearningContent'" class="learning entity-detail ace_sec_txt">
            <template v-if="((course.courseType === 'RICH_HTML_SUPPORT') && (entity.type === 'RICH_HTML'))">
              <template v-if="isEntityDetailLoaded">
                <rich-html-launch-assessment :resource-id="entityUuid" :html="entity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml" :container-class="'rich-html-container'" ></rich-html-launch-assessment>
              </template>
            </template>
            <template v-else>
              <div v-if="entity.type === 'ASSESSMENT'">
                <template v-if="isEntityDetailLoaded">
                  <assessment-detail-instructor :uuid ="entity.uuid" :course-id="course.uuid" :course="course"></assessment-detail-instructor>
                </template>
              </div>
              <div v-else>
                <b-button :to="{ name: 'entityLearnInstructor', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Preview Resource">Preview Resource</b-button>
              </div>
            </template>
          </div>
          <div v-else>
            <!--
            <p>Progress</p>
            <hr>
            <b-card class="course-description-card"></b-card>

            <p>Competencies</p>
            <hr>
            <b-card class="course-description-card"></b-card>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOCInstructor from './TOCInstructor'
import { PACKAGE } from '../../../package_constants'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import AssessmentDetailInstructor from '../../assessment/components/AssessmentDetailInstructor'
import CopyToClipboard from 'vue-copy-to-clipboard'
import Vuelidate from 'vuelidate'
import {required, minValue} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)


export default {
  name: 'course-learn',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid'],
  components: {
    CourseHeader,
    CourseNav,
    TOCInstructor,
    AssessmentDetailInstructor,
    RichHtmlLaunchAssessment,
    CopyToClipboard
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      nextTOCuuid: null,
      prevTOCuuid: null,
      entityActivity: null,
      aiResorce : {},
      competencyLogic : {message:'', messageTitle:'', postMessageId:''},
      messageTitle : '',
      message : '',
      'postMessageId': '',
      aiContentMap : {},

    }
  },
validations: {
    messageTitle: {
      required
    },
    message: {
      required
    }
  },
  mounted () {
    if (this.isStudentLogin) {
      return this.$router.push({ name: 'entityDetail', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid, topicUuid: this.topicUuid, subTopicUuid: this.subTopicUuid } })
    }
    this.loadCourse()
    if ($('#ic_' + this.entityUuid).hasClass('collapsed')) {
      $('#ic_' + this.entityUuid).trigger('click')
    }
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadCourseTopics',
      'loadEntityDetail',
      'loadEntityActivity',
      'loadAIContents',
      'loadAIContents',
      'loadAIResource',
      'saveCompetencyLogicMessage',
      'getCompetencyLogicMessage',
      'deleteCompetencyLogicMessage'
    ]),

    async loadCourse () {
      this.isEntityActivityLoaded = false
      this.loadCourseDetail(this.uuid)
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.aiContentMap = await this.loadAIContents(this.uuid)
      this.loadEntityActivity(entityActityInfo).then(res => {
        if (res) {
          this.entityActivity = res
          if (this.entityActivity.status === 2 || this.entityActivity.status === 3) {
            this.isEntityActivityLoaded = true
          }
        }
      })
      const loadDataFromServer = (this.entity) ? (this.entity.uuid !== this.entityUuid) : true
      this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: loadDataFromServer}).then(res => {
        var i = 0
        var j = 0
        var k = 0
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entityUuid) {
            for (j = i + 1; j < this.linearTopics.length; j++) {
              if (this.linearTopics[j] && this.linearTopics[j].objectType !== 'LearningTopic') {
                this.nextTOCuuid = this.linearTopics[j].uuid
                break
              }
            }
            for (k = i - 1; k >= -1; k--) {
              if (k === -1 && this.nextTOCuuid !== null) {
                k = this.linearTopics.length - 1
              }
              if (this.linearTopics[k] && this.linearTopics[k].objectType !== 'LearningTopic') {
                this.prevTOCuuid = this.linearTopics[k].uuid
                break
              }
            }
            break
          }
        }
        if (j < k) {
          this.prevTOCuuid = null
        }

        if (j === this.linearTopics.length) {
          this.nextTOCuuid = null
        }
      })
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then(res => {
        if (res && ((res.type === 'ASSESSMENT') || (res.type === 'RICH_HTML'))) {
          this.isEntityDetailLoaded = true
        }
      })
    },
    generateLTIUrlForCMC (courseId, topicId, assetId) {
      if(this.course.includeCAI || this.course.includeCDesc){
        let url = window.location.protocol + '//' + window.location.host +'/connect/processurl?courseid='+courseId +'&tid='+this.entityUuid
        return url
      }else{
        let url = window.location.protocol + '//' + window.location.host +'/connect/processurl?courseid='+courseId +'&tid='+this.entityUuid +'&aid='+this.nextTOCuuid
        return url
      }
    },
    allowCopyLTILink () {
      let allowCopyLTILink = this.enabledFeatures['allowCopyLTILink']
      if (!allowCopyLTILink || !allowCopyLTILink.enabled) {
        return false
      }
      return allowCopyLTILink.enabled
    },
    allowEditKC (){
      let allowEditKCFeature = this.enabledFeatures['allowEditKC']
      if (!allowEditKCFeature || !allowEditKCFeature.enabled) {
        return false
      }
      return allowEditKCFeature.enabled
    },
    closeAiContentModal () {
        this.$refs.aiContentModal.hide()
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },

    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    openAiContentModal () {
    if(this.$refs.aiContentModal){
      var entityDetailInfo = {
        'entityUuid': this.aiResorce.uuid,
        'entityType': 'LearningContent'
      }
        this.loadAIResource(entityDetailInfo).then(res => {
          this.aiResorce = res
          this.$refs.aiContentModal.show()
        })
    }
    },
    editKC (kc) {
      let url = window.location.protocol + '//' + window.location.host +'/vue/#/assessment/'+kc.uuid+'/edit'
      window.open(url, '_blank')
    },

    openPostMessageEditModal () {
      this.message = ''
      this.messageTitle = ''
      this.postMessageId = ''
      this.getCompetencyLogicMessage({courseId:this.course.uuid,topicId: this.entity.competencies[0], type:'POST'}).then(res => {
          this.competencyLogic = res
          this.message = this.competencyLogic.message
          this.messageTitle = this.competencyLogic.messageTitle
          this.postMessageId = this.competencyLogic.uuid
          this.$refs.postMessageEditModal.show()
        })
    },
    deleteAndCloseCompetencyLogicMessage () {
        if(confirm('Do you want to delete the message?')){
          this.deleteCompetencyLogicMessage(this.postMessageId).then(res => {
            this.competencyLogic = {message:'', messageTitle:'', postMessageId:''}
            this.notifyMessageDelete(this.entity.title)
            this.$refs.postMessageEditModal.hide()
          })
        }
    },
    saveAndCloseCompetencyLogicMessage () {
        if (this.messageTitleState) {
          this.competencyLogic.message = this.message
          this.competencyLogic.messageTitle = this.messageTitle
          this.saveCompetencyLogicMessage(this.competencyLogic).then(res => {
            this.notifyMessageSaved(this.entity.title)
            this.competencyLogic = res
            this.$refs.postMessageEditModal.hide()
          })
        }
    },
    closePostMessageEditModal () {
        this.$refs.postMessageEditModal.hide()
    },

    msToTime (s) {
      if (s === undefined) {
        return '0 hrs 0 mins 0 seconds'
      }
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    },
    scrollUpToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 120, scrollLeft: 0}, 300)
    },
    scrollToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0}, 300)
    },
    afterRenderRichHtml () {
      this.$refs.courseHeader.hideToc()
    },
    generateLTIUrl (courseId, topicId, assetId) {
      let url = window.location.protocol + '//' + window.location.host +'/connect/processurl?courseid='+courseId +'&tid='+topicId +'&aid='+assetId
      return url
    },
    notifyMessageDelete(messageType) {
      setTimeout(() => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Post completion message for '+messageType+ 'deleted.'
        })
      }, 0)
    },
    notifyMessageSaved (messageType) {
      setTimeout(() => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Post completion message for '+messageType+ 'saved.'
        })
      }, 0)
    },
    notifyUrlCopiedMessage (messageType) {
      setTimeout(() => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: messageType + ' Url is copied for LMS embedding.'
        })
      }, 0)
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'entity': state => state.course.entity,
      'isTocOpen': state => state.course.isTocOpen,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'linearTopics': state => state.course.linearTopics
    }),
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    },
    messageTitleState () {
      return this.messageTitle && this.messageTitle.length > 0
    },
    messageState () {
      return this.message.length > 0
    },

    allowCopyLTILink () {
      let allowCopyLTILink = this.enabledFeatures['allowCopyLTILink']
      if (!allowCopyLTILink || !allowCopyLTILink.enabled) {
        return false
      }
      return allowCopyLTILink.enabled
    }
  },
  watch: {
    entityUuid (newId) {
      if (newId) {
        if(this.aiContentMap[newId]){
          this.aiResorce = {uuid:this.aiContentMap[newId]}
        }else{
          this.aiResorce = {}
        }
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:0px;
  padding-left:0px;
  padding-right:0px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}

.entity-nav{
  padding-left: 25px;
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}
.entity-title {
	margin-bottom:0px;
	font-size: 20px;
	max-width: calc(100% - 35px);
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: robotoSlab_Light;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
	-webkit-box-orient: vertical;
	position:relative;
	max-height:49px;
	padding-right:16px;
}

.next, .previous {
	font-weight: bold!important;
    font-size: 18px;
    padding: 0px 11px 0px 11px!important;
	margin-right:4px;
}
.entity-title-section {
	width: calc(100% - 277px);
	display: flex;
    align-items: center;
    height: 63px;
}
img {
	width:28px;
	height:26px;
}

.roboto-text {
	font-size:17px;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityDetailInstructor.vue